var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000151038 1.4188L1.41436 0.00458592L7.77833 6.36855L6.36411 7.78276L0.000151038 1.4188Z",
    fill: "#515151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19546 10.6141L10.6097 9.1999L16.9736 15.5639L15.5594 16.9781L9.19546 10.6141Z",
    fill: "#515151"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6095 7.77817L9.19531 6.36396L15.5593 0L16.9735 1.41421L10.6095 7.77817Z",
    fill: "#515151"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41421 16.9735L0 15.5593L6.36396 9.19531L7.77817 10.6095L1.41421 16.9735Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1d4b9dd63d76c1ecd6878c55cf3a1a94.svg";
export { ForwardRef as ReactComponent };